import { stripHtml } from '../../../utils/caretUtils';
import { escapeHtml } from '../../../utils/pasteUtils/htmlEscape';

/** Cheap content fingerprint for minimap invalidation. */
export const codeContentRev = (text) => {
  const s = text || '';
  let h = 2166136261;
  for (let i = 0; i < s.length; i += 1) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return `${s.length}:${h >>> 0}`;
};

const isStoredCodeHtml = (raw) =>
  !raw ||
  /data-doc-variable|data-doc-math/i.test(raw) ||
  /<br\s*\/?>/i.test(raw) ||
  /&(?:lt|gt|amp|nbsp);/i.test(raw);

/** Normalize line breaks to `\n`; migrate legacy `<br>` markers. */
export const canonicalizeCodeHtml = (html) =>
  (html || '').replace(/\r\n?/g, '\n').replace(/<br\s*\/?>/gi, '\n');

/** True when a code block has no visible characters (ZWSP / nbsp / newlines only). */
export const isEmptyCodeContent = (html) =>
  stripHtml(canonicalizeCodeHtml(html || ''))
    .replace(/[\u200B\u00a0]/g, '')
    .replace(/&nbsp;/gi, '')
    .trim() === '';

/** Legacy plain textarea content → safe HTML (newlines kept as `\n`). */
export const normalizeCodeContent = (raw) => {
  if (!raw) return '';
  if (isStoredCodeHtml(raw)) return canonicalizeCodeHtml(raw);
  return escapeHtml(raw).replace(/\r\n?/g, '\n');
};

export const countCodeLines = (html) => {
  const host = document.createElement('div');
  host.innerHTML = canonicalizeCodeHtml(html);
  const text = host.textContent || '';
  let n = 1;
  for (let i = 0; i < text.length; i += 1) if (text[i] === '\n') n += 1;
  return n;
};
